import { apiClient } from "./client";
import type { Lesson, LessonSaveInput } from "@/types/group";

export async function fetchGroupLessons(groupId: string): Promise<Lesson[]> {
  const { data } = await apiClient.get<Lesson[]>(`/groups/${groupId}/lessons`);
  return data;
}

export async function fetchLessonByDate(groupId: string, date: string): Promise<Lesson | null> {
  const { data } = await apiClient.get<Lesson[]>(`/groups/${groupId}/lessons`, { params: { date } });
  return data[0] ?? null;
}

export async function saveLessonAttendance(payload: LessonSaveInput): Promise<Lesson> {
  const { data } = await apiClient.post<Lesson>(`/groups/${payload.groupId}/lessons`, payload);
  return data;
}

export async function patchLessonAttendance(lessonId: string, payload: Partial<LessonSaveInput>): Promise<Lesson> {
  const { data } = await apiClient.patch<Lesson>(`/lessons/${lessonId}/attendance`, payload);
  return data;
}
